<template>
  <div>
    <FormulateInput
      type="select"
      :label="label"
      v-model="categoryID"
      :options="
        sortBy(
          category.children.map(cat => {
            return { label: cat.title, value: cat.id }
          }),
          c => c.label
        )
      "
      input-class="form-select"
      validation="required"
      :validation-name="label"
      placeholder="Select an option"
    />
    <div v-if="selectedCategory && Array.isArray(selectedCategory.children)">
      <clipart-category-field :category="selectedCategory" v-model="data" />
    </div>
  </div>
</template>
<script>
import { sortBy } from 'lodash'
export default {
  name: 'clipart-category-field',
  props: {
    value: {
      type: String
    },
    category: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      data: this.value,
      categoryID: this.value,
      selectedCategory: null
    }
  },
  watch: {
    value(val) {
      this.data = val
    },
    data(val) {
      this.$emit('input', val)
    },
    categoryID(val) {
      var selectedCategory = this.category.children.find(cat => cat.id === val)
      this.selectedCategory = selectedCategory
      if (selectedCategory && selectedCategory.children === null) {
        this.$emit('input', val)
      } else {
        this.$emit('input', null)
      }
    }
  },
  methods: {
    sortBy: sortBy
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/ClipartCategoryField.vue